import React from 'react'
import PropTypes from 'prop-types'

import Svg from '../Svg'

import chevronRight from '../../../../svg/chevron-right.svg'

import '../../../scss/components/_carousel-decorators.scss'

const RightArrow = ({nextSlide, trackingCall}) => (
  <button
    className="c-carousel-arrow c-carousel-arrow--right"
    onClick={() => {
      nextSlide()
      trackingCall()
    }}
    type="button"
  >
    <span className="u-sr-only">Navigate to next carousel item</span>
    <Svg className="c-carousel-arrow-svg" src={chevronRight} Tag="span" />
  </button>
)

RightArrow.propTypes = {
  nextSlide: PropTypes.func.isRequired,
  trackingCall: PropTypes.func.isRequired,
}

export default RightArrow
